
const devLog = window.location.hostname === "localhost" ? console.log : () => { }

export default devLog
